import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID, signal } from '@angular/core';

export enum DeviceTypeEnum {
  DESKTOP,
  TABLET,
  MOBILE,
}

export type WindowResolutionData = {
  device: DeviceTypeEnum;
  width: number;
};

@Injectable({ providedIn: 'root' })
export class WindowResizeService {
  windowResolutionData = signal<WindowResolutionData>({
    device: this._getDeviceType(this._getInitialWidth()),
    width: this._getInitialWidth(),
  });

  constructor(@Inject(PLATFORM_ID) private readonly _platformId: Object) {
    this._setupResizeListener();
  }

  private _getInitialWidth(): number {
    if (isPlatformServer(this._platformId)) return 0;

    return window.innerWidth;
  }

  private _setupResizeListener(): void {
    if (isPlatformServer(this._platformId)) return;

    window.addEventListener('resize', () => {
      const currentWidth = window.innerWidth;

      if (currentWidth === this.windowResolutionData().width) return;

      this.windowResolutionData.set({
        device: this._getDeviceType(currentWidth),
        width: currentWidth,
      });
    });
  }

  private _getDeviceType(width: number): DeviceTypeEnum {
    if (width <= 768) {
      return DeviceTypeEnum.MOBILE;
    } else if (width <= 1024) {
      return DeviceTypeEnum.TABLET;
    } else {
      return DeviceTypeEnum.DESKTOP;
    }
  }
}
